import { render, staticRenderFns } from "./AddBlacklistModal.vue?vue&type=template&id=471c7906"
import script from "./AddBlacklistModal.vue?vue&type=script&lang=js"
export * from "./AddBlacklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports